export const GET_DISTRICT_BEGIN = "GET_DISTRICT_BEGIN"
export const GET_DISTRICT_SUCCESS = "GET_DISTRICT_SUCCESS"
export const CLEAR_DISTRICT = "CLEAR_DISTRICT"